/*
  Delete a CSS highlight by name, working around iOS WebView quirks:
  - Calling `delete` on a missing name breaks subsequent deletes; guard with `.has()`.
  - `clear` is more reliable than `delete` when only one name is registered.

  Use this whenever you'd otherwise call `CSS.highlights.delete(name)`.
*/
export default function deleteCssHighlight(name: string): boolean {
  if (!CSS.highlights.has(name)) {
    return false;
  }

  if (CSS.highlights.size === 1) {
    CSS.highlights.clear();
    return true;
  }

  return CSS.highlights.delete(name);
}
